<template>
    <div>
        <swb-query-sort-area ref="query_model_ctrl" :config="queryConfig" :queryHandler="queryHandler" :eventHandler="queryEventHanlder" :popupHandler="popupHandler"></swb-query-sort-area>
        <div class="column-layout">
            <div v-if="checkBox" class="table-layout">
                <el-table ref="multipleTable" :data="retailerShopList" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column :key="Math.random()" :selectable="selectable" v-if="checkBox" type="selection" width="55"></el-table-column>
                    <el-table-column v-if="filter != null && !filter.filterMerchantId" prop="merchantName" label="商户名称" align="left" width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column :key="Math.random()" prop="name" label="机构名称" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column :key="Math.random()" label="门店标识" width="110" align="left">
                        <template slot-scope="rows">
                            <el-tag type="success" v-if="rows.row.shopFlag && rows.row.tagName != null">{{rows.row.tagName}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column :key="Math.random()" prop="contactName" label="联系人" align="left"></el-table-column>
                    <el-table-column :key="Math.random()" prop="contactTel" label="联系电话" align="center"></el-table-column>
                    <el-table-column :key="Math.random()" prop="contactEmail" label="联系电子邮箱" align="center"></el-table-column>
                    <el-table-column :key="Math.random()" label="地址" align="left" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.regionName != null">{{rows.row.regionName}}</span>
                            <span v-if="rows.row.street != null">{{rows.row.street}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="table-layout" v-else>
                <el-table :data="retailerShopList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column :key="Math.random()" width="55">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : checkedRetailerShop!= null && checkedRetailerShop.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :key="Math.random()" prop="name" label="机构名称" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column :key="Math.random()" label="门店标识" align="left">
                        <template slot-scope="rows">
                            <el-tag type="success" v-if="rows.row.shopFlag && rows.row.tagName != null">{{rows.row.tagName}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column :key="Math.random()" prop="contactName" label="联系人" align="left"></el-table-column>
                    <el-table-column :key="Math.random()" prop="contactTel" label="联系电话" align="center"></el-table-column>
                    <el-table-column :key="Math.random()" prop="contactEmail" label="联系电子邮箱" align="left"></el-table-column>
                    <el-table-column :key="Math.random()" label="地址" align="left" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.regionName != null">{{rows.row.regionName}}</span>
                            <span v-if="rows.row.street != null">{{rows.row.street}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils, EventBus } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { openRegionForSelectDlg } from '../comn/regionSelectDlg'

    import retailerApi from '../../api/retailer'

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "机构名称",
            "code": "name",
            "basic": true
        }, {
            "type": "Checkbox",
            "valueType": "Boolean",
            "label": "仅门店",
            "code": "queryShop",
            "value": true,
            "basic": true
        }, {
            "type": "Select",
            "label": "门店标识",
            "code": "tagId",
            "basic": true,
            "dataList": []
        }, {
            "type": "Popup",
            "valueType": "Integer",
            "label": "地区",
            "code": "regionId",
            "basic": true
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-retailer-shop-list-for-select',
        desc: '零售商基本信息',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            operation: {
                type: String,
                default: null
            },
            action: {
                type: String,
                default: null
            },
            checkedItems: {// 回显的时候传入(单选多选均可用)
                type: Array,
                default: function () {
                    return [];
                }
            },
            checkedIds: {// 回显的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            disableIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            isRetailerRel: {
                type: Boolean,
                default: false
            },
            ebChannel: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                //分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),

                //复选信息
                checkedIdsX: [],
                checkedIdMap: {},
                checkedDelay: 100,
                checkedIniting: false,
                checkedList: [],
                retailerShopList: [],
                checkedRetailerShop: null,
                //
                //排序、搜索
                queryConfig: {},
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                selectRetailerShopList: [],
                //
                provinceId: null,
                cityId: null,
                countyId: null,
            }
        },
        watch: {
            checkedIds(newVal, oldVal){
                let self = this;
                let operation = this.operation;
                if(newVal != oldVal && operation != null && operation != "shop") {
                    newVal = newVal == null ? [] : newVal;
                    oldVal = oldVal == null ? [] : oldVal;
                    let lesIds = null;
                    if(this.action == 'add') {
                        lesIds = Utils.compareArrays(oldVal, newVal)["less"];
                    } else {
                        lesIds = Utils.compareArrays(newVal, oldVal)["less"];
                    }
                    this.checkedIdsX = newVal.clone();
                    let retailerShopList = this.checkedItems || [];
                    let checkedList = [];
                    this.checkedIdsX.forEach(function (id) {
                        for(let i = 0; i < retailerShopList.length; i++) {
                            let retailerShop = retailerShopList[i];
                            if(id == retailerShop.id) {
                                checkedList.add(retailerShop);
                            }
                        }
                    });
                    self.checkedList = checkedList;
                    self.checkedIniting = true;
                    let rows = this.retailerShopList;
                    rows.forEach(function (row) {
                        if(lesIds.indexOf(row.id) >= 0) {
                            self.$refs['multipleTable'].toggleRowSelection(row);
                        }
                    });
                    self.checkedIniting = false;
                    //
                    if(Utils.isFalse(self.checkBox) && !Utils.isNoB(self.checkedIds) && self.checkedIds.length > 0) {
                        for(let i = 0; i < retailerShopList.length; i++) {
                            let retailerShop = retailerShopList[i];
                            if(self.checkedIds[0] == retailerShop.id) {
                                self.checkedRetailerShop = Utils.merge({}, retailerShop);
                            }
                        }
                    }
                    // this.getRetailerComList();
                }
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //
            this.queryModel.filterItems.queryShop = true;
            //
            this.checkedIdsX = this.checkedIds || [];
            if(!Utils.isNoB(this.checkedItems) && this.checkedItems.length > 0) {
                this.checkedList = Utils.merge([], this.checkedItems);
            }
            if(Utils.isFalse(this.checkBox) && !Utils.isNoB(this.checkedItems) && this.checkedItems.length > 0) {
                this.checkedRetailerShop = Utils.merge({}, this.checkedItems[0]);
            }
            //
            this.getRetailerShopTagList();
        },
        methods: {
            selectable: function (row, index) {
                let disableIds = this.disableIds;
                if(disableIds.indexOf(row.id) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            // 仅门店选择
            queryEventHanlder: function (itemCode, eventName, itemValue, filterItems) {
                //模拟代码：当审核状态变为“已审核”时隐藏“包含已删除的”字段，禁用销售金额字段；
                if(eventName == 'change') {
                    //
                    if(itemCode == 'queryShop') {
                        itemValue = itemValue == null ? false : itemValue;
                        if(this.queryModel.filterItems.queryShop != itemValue) {
                            this.queryModel.filterItems.queryShop = itemValue;
                            if(Utils.isTrue(this.checkBox)) {
                                this.checkedIniting = true;
                            }
                            this.pageNumber = 1;
                            this.getRetailerComList();
                        }
                    }
                    // 清除地区过滤
                    let queryFields = this.queryConfig.queryFields;
                    if(itemCode == 'regionId' && Utils.isNoB(itemValue)) {
                        let regionItem = queryFields.find(function (field) {
                            return field.code == 'regionId';
                        });
                        //
                        regionItem.forcedValue = null;
                        regionItem.text = null;
                        this.provinceId = null;
                        this.cityId = null;
                        this.countyId = null;
                        //
                        let query_model_ctrl = this.$refs['query_model_ctrl'];
                        let data = {forcedValue: null, text: null};
                        let fieldInfo = {};
                        fieldInfo[itemCode] = data;
                        query_model_ctrl.updateFields(fieldInfo);
                    }
                }
            },
            //
            queryHandler(queryModel) {
                if(this.checkedIniting) {
                    return;
                } else {
                    if(Utils.isTrue(this.checkBox)) {
                        this.checkedIniting = true;
                    }
                }
                this.pageNumber = 1;
                this.queryModel = queryModel;
                this.getRetailerComList();
            },
            // 根据不同信息变换查询信息
            popupHandler: function (fieldCode, curValue, curText) {
                let self = this;
                if(fieldCode == 'regionId') {
                    let params = {
                        provinceId: self.provinceId,
                        cityId: self.cityId,
                        countyId: self.countyId,
                    };
                    openRegionForSelectDlg(params, function (result) {
                        let query_model_ctrl = self.$refs['query_model_ctrl'];
                        let fieldInfo = {
                            regionId: {
                                value: result.regionId,
                                text: result.regionName
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                        self.provinceId = result.provinceId;
                        self.cityId = result.cityId;
                        self.countyId = result.countyId;
                    });
                }
            },
            // ===================== 分页多选开始 ==============================
            handleCurrentChange: function (val) {
                this.checkedRetailerShop = Utils.merge({}, val);
            },
            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                let allIds = self.retailerShopList.pluck("id");
                let selIds = selRows.pluck("id");
                selIds.forEach(function (id, index) {
                    self.addCheckId(id, selRows[index]);
                });

                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (id, index) {
                    self.delCheckId(id);
                });
                //
            },
            addCheckId: function (id, val) {
                if(this.checkedIdsX.indexOf(id) < 0) {
                    this.checkedIdsX.add(id);
                    this.checkedList.add(val);
                    let item = {};
                    item.checkedIds = this.checkedIdsX;
                    item.operation = "shop";
                    item.action = "add";
                    this.$emit("handle-change", item);
                    return id;
                }
                return null;
            },
            delCheckId: function (id) {
                let self = this;
                console.log(self.checkedIdsX);
                if(self.checkedIdsX.indexOf(id) >= 0) {
                    for(let i = 0; i < self.checkedList.length; i++) {
                        let checkedShop = this.checkedList[i];
                        if(checkedShop.id == id) {
                            self.checkedList.splice(i, 1);
                        }
                    }
                    console.log(id);
                    self.checkedIdsX.remove(id);
                    //
                    let item = {};
                    item.checkedIds = self.checkedIdsX;
                    item.operation = "shop";
                    item.action = "del";
                    this.$emit("handle-change", item);
                    return id;
                }
                return null;
            },
            hashCheckedId(id){
                return this.X.contains(id);
            },

            // ===================== 分页多选结束 ==============================
            //===========回显禁用===============

            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                //
                this.handlePageChange(newPageNumber);

            },
            handlePageChange: function (val) {
                if(this.checkedIniting) {
                    return;
                } else {
                    if(Utils.isTrue(this.checkBox)) {
                        this.checkedIniting = true;
                    }
                }
                //
                this.pageNumber = val;
                //
                this.getRetailerComList();
            },
            //
            getRetailerComList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let name = filterItems.name || null;
                let tagId = filterItems.tagId || null;
                let queryShop = filterItems.queryShop || false;
                //
                let filterList = self.filter || [];
                for(let filterCode in filterList) {
                    filterItems[filterCode] = filterList[filterCode];
                }
                //
                filterItems.name = name;
                filterItems.tagId = tagId;
                //
                filterItems.queryAll = !queryShop;
                //
                if(!Utils.isNoB(filterItems.regionId)) {
                    filterItems.regionId = null;
                    //
                    filterItems.provinceId = self.provinceId;
                    filterItems.cityId = self.cityId;
                    filterItems.countyId = self.countyId;
                }
                filterItems.closed = false;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let loading = MsgBox.loading();
                retailerApi.getRetailerShopList(postData, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        let data = result.data;
                        self.retailerShopList = data.rows || [];
                        //
                        setTimeout(function () {
                            // 处理回
                            if(self.checkBox) {
                                let selectedIds = self.checkedIds;
                                self.selectRows(selectedIds, self.retailerShopList);
                            }
                        }, self.checkedDelay);
                        self.totalCount = data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            selectRows: function (selectRows, rows) {
                let self = this;
                this.checkedIniting = true;
                if(selectRows) {
                    rows.forEach(function (row) {
                        if(selectRows.indexOf(row.id) >= 0) {
                            self.$refs['multipleTable'].toggleRowSelection(row);
                        }
                    });
                }
                this.checkedIniting = false;
            },
            //
            getRetailerShopTagList: function () {
                let self = this;
                let filter = this.filter;
                let postData = {};
                postData.filterItems = {
                    retailerId: filter.merchantId
                };
                //
                let loading = MsgBox.loading();
                retailerApi.getRetailerShopTagList(postData, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        let retailerShopTagList = result.data;
                        //
                        self.setTagNameQueryFilter(retailerShopTagList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            setTagNameQueryFilter: function (retailerShopTagList) {
                //
                let queryConfig = Utils.merge({}, searchConfigData);
                let queryConfigMap = queryConfig.queryFields.toMap("code");
                if(retailerShopTagList.length > 0) {
                    let dataList = [];
                    dataList.push({
                        value: null,
                        label: "-全部-"
                    });
                    for(let i = 0; i < retailerShopTagList.length; i++) {
                        let shopTag = retailerShopTagList[i];
                        let item = {
                            value: shopTag.id,
                            label: shopTag.name
                        };
                        dataList.push(item);
                    }
                    //
                    let noItem = queryConfigMap['tagId'];
                    noItem.dataList = dataList || [];
                }
                this.queryConfig = Utils.merge({}, queryConfig);
                //
                this.getRetailerComList();
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                if(Utils.isTrue(self.checkBox)) {
                    //
                    let selectRetailerShopList = self.checkedList;
                    selectRetailerShopList = selectRetailerShopList || [];
                    if(selectRetailerShopList.length <= 0) {
                        result.type = 'warn';
                        result.message = "请至少选择一个机构";
                    } else {
                        result.type = 'info';
                        result.data = selectRetailerShopList;
                    }
                } else {
                    let selectRetailerShop = self.checkedRetailerShop || {};
                    if(Utils.isNoB(selectRetailerShop) || Utils.isNoB(selectRetailerShop.id)) {
                        result.type = 'warn';
                        result.message = "请选择机构";
                    } else {
                        result.type = 'info';
                        result.data = selectRetailerShop;
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/RetailerShopListForSelect.vue